import React from 'react'
import Button, { TYPES as BUTTON_TYPES } from 'components/Button'
import { ICON_TYPES } from 'components/Icon.v2'

/**
 * The play video CTA component
 * @param {Map} props.share - The share data
 * @param {Function} props.onClick - The play button click handler
 * @returns {JSX.Element} CTA component
 */
function SharePageV3VideoPlayCTA (props) {
  const {
    share,
    onClick,
  } = props

  const imageNoText = share.getIn(['content', 'imageNoText'])

  return (
    <div className="share-page-v3__video-play">
      <div
        className="share-page-v3__video-poster"
        style={imageNoText ? { backgroundImage: `url(${imageNoText}}` } : null}
      >
        <div className="share-page-v3__video-overlay">
          <Button
            className="share-page-v3__video-overlay-control"
            type={BUTTON_TYPES.ICON}
            onClick={onClick}
            icon={ICON_TYPES.PLAY}
          />
        </div>
      </div>
    </div>
  )
}

export default SharePageV3VideoPlayCTA
